import React, { useState, Fragment, useEffect } from "react";

//Imports material-ui
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Server } from "../../services/server";
import { pdf } from '@react-pdf/renderer';
import DocumentRecibo from "../../components/DocumentRecibo";

export default function VentaModalDetalle(props) {
    const server = new Server();
    const [responseReciboData, setResponseReciboData] = useState();

    useEffect(() => {
        reloadDetail()
    }, []);

    async function reloadDetail() {
        const responseRecibo = await server.getDetailVenta(props.ventaSelected.id_venta);
        if (responseRecibo.status === 200) {
            const responseReciboDataPrivate = await responseRecibo.data;
            setResponseReciboData(responseReciboDataPrivate)
        }
    }
    async function handleView() {
        const blob = await pdf(<DocumentRecibo recibo={responseReciboData} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
    };

    /*async function handleDownload() {
        const blob = await pdf(<DocumentRecibo recibo={responseReciboData} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'recibo - '+responseReciboData.nro_recibo+".pdf"; // Cambia el nombre del archivo aquí
        link.click();
        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 10000);// Limpia el objeto URL temporal
    };*/

    async function handleDownload() {
        if (!responseReciboData) return;

        try {
            const blob = await pdf(
                <DocumentRecibo recibo={responseReciboData} />
            ).toBlob();

            const file = new File(
                [blob],
                `recibo-${responseReciboData.nro_recibo}.pdf`,
                { type: 'application/pdf' }
            );

            const url = URL.createObjectURL(file);

            const link = document.createElement('a');
            link.href = url;
            link.download = file.name;
            link.style.display = 'none';

            document.body.appendChild(link);

            link.click();

            setTimeout(() => {
                link.remove();
                URL.revokeObjectURL(url);
            }, 30000);

        } catch (error) {
            console.error("Error al generar o descargar PDF:", error);
        }
    }


    return (
        <Fragment>
            <DialogTitle>Detalle de Recibo</DialogTitle>
            <DialogActions>
                <Button onClick={handleView} variant="outlined" color="info">Visualizar</Button>
                <Button onClick={handleDownload} variant="contained" color="success" >Descargar</Button>
            </DialogActions>
        </Fragment>
    );
}